import Icon from '@ant-design/icons';
import { trpc } from '@tencent/tpro_rmonitor_user_manager_user_role_auth';
import { Space } from 'antd';
import React, { ReactElement, ReactNode } from 'react';
import i18n from '@/i18n';
import AdminIcon from '@/assets/images/public/perm/admin.react.svg?react';
import DeveloperIcon from '@/assets/images/public/perm/developer.react.svg?react';
import OperatorIcon from '@/assets/images/public/perm/operator.react.svg?react';
import { WithTypeCast } from '@raft/utils';
type IRole = WithTypeCast<trpc.rmonitor.user_manager.IRole>;

export enum AdminProductPermission {
  Product = 'product',
  ProductDelete = 'productDelete',
  ProductInfoEdit = 'productInfoEdit',
  ProductMember = 'productMember',
  RolePermission = 'rolePermission',
  VersionManage = 'versionManage',
  DailyReportManage = 'dailyReportManage',
}

export enum DeveloperProductPermission {

}

export enum OperatorProductPermission {

}

export const productPermissionMap = {
  [AdminProductPermission.Product]: i18n.t('产品管理'),
  [AdminProductPermission.ProductInfoEdit]: i18n.t('产品信息修改'),
  [AdminProductPermission.ProductMember]: i18n.t('产品成员管理'),
  [AdminProductPermission.RolePermission]: i18n.t('角色权限配置'),
  [AdminProductPermission.VersionManage]: i18n.t('版本管理'),
  [AdminProductPermission.DailyReportManage]: i18n.t('日报配置'),
  [AdminProductPermission.ProductDelete]: i18n.t('产品删除'),
};

export const developerProductPermissionMap = {

};

export const operatorProductPermissionMap = {

};

export enum CrashReportPermission {
  Alarm = 'alarm',
  Symbol = 'symbol',
  Check = 'check',
}

export type RolePermission = IRole & {
  permissions: string[]
};


export type PermissionNode = {
  value: number | string;
  label: string;
  disabled?: boolean;
  render?: () => ReactElement;
};

export enum PermNodeValue {
  // 联网设备数
  DauDeviceUV = 'dau_device_uv',
  // 启动次数
  DauLaunchTimes = 'dau_launch_times',
  // 发生次数
  DauCount = 'dau_count',
  // 影响设备数
  QimeiCount = 'qimei_count'
}

export enum Role {
  Admin = 'admin',
  Dev = 'dev',
  Op = 'op'
}

export const permissionNodes = {
  editProductInfo: {
    value: 1,
    label: i18n.t('产品信息修改'),
    disabled: true,
  },
  deleteProduct: {
    value: 1,
    label: i18n.t('产品删除'),
    disabled: true,
  },
  memberManage: {
    value: 1,
    label: i18n.t('产品成员管理'),
    disabled: true,
  },
  permissionManage: {
    value: 1,
    label: i18n.t('角色权限管理'),
    disabled: true,
  },
  dailyReport: {
    value: 1,
    label: i18n.t('日报配置'),
    disabled: true,
  },
  tapdConfig: {
    value: 1,
    label: i18n.t('TAPD配置'),
    disabled: true,
  },
  appVersionManage: {
    value: 1,
    label: i18n.t('应用版本管理'),
    disabled: true,
  },
  tagManage: {
    value: 1,
    label: i18n.t('标签管理'),
    disabled: true,
  },
  userCustom: {
    value: 1,
    label: i18n.t('自定义维度'),
    disabled: true,
  },
  issueCluster: {
    value: 1,
    label: i18n.t('Issue聚类配置'),
    disabled: true,
  },
  addSdkConfig: {
    value: 1,
    label: i18n.t('新建配置任务'),
    disabled: true,
  },
  editSdkConfig: {
    value: 1,
    label: i18n.t('编辑配置任务'),
    disabled: true,
  },
  deleteSdkConfig: {
    value: 1,
    label: i18n.t('删除配置任务'),
    disabled: true,
  },
  viewSdkConfig: {
    value: 1,
    label: i18n.t('查看配置任务'),
    disabled: true,
  },
  viewSdkConfigHistory: {
    value: 1,
    label: i18n.t('查看配置修改历史'),
    disabled: true,
  },

  addAlertConfig: {
    value: 1,
    label: i18n.t('新建告警任务'),
    disabled: true,
  },
  editAlertConfig: {
    value: 1,
    label: i18n.t('编辑任意告警任务'),
    disabled: true,
  },
  deleteAlertConfig: {
    value: 1,
    label: i18n.t('删除任意告警任务'),
    disabled: true,
  },
  viewAlertConfig: {
    value: 1,
    label: i18n.t('查看任意告警任务'),
    disabled: true,
  },
  toggleAlertConfig: {
    value: 1,
    label: i18n.t('开启/关闭任意告警任务'),
    disabled: true,
  },
  viewAlertHistory: {
    value: 1,
    label: i18n.t('查看告警历史'),
    disabled: true,
  },
  // 符号表
  uploadSymbol: {
    value: 1,
    label: i18n.t('上传符号表'),
    disabled: true,
  },
  viewSymbolList: {
    value: 1,
    label: i18n.t('查看符号表列表'),
    disabled: true,
  },
  // 数据管理
  deviceDAU: {
    value: PermNodeValue.DauDeviceUV,
    label: i18n.t('联网设备数'),
  },
  launchDAU: {
    value: PermNodeValue.DauLaunchTimes,
    label: i18n.t('启动次数'),
  },
  countDAU: {
    value: PermNodeValue.DauCount,
    label: i18n.t('发生次数'),
    disabled: true,
  },
  deviceUV: {
    value: PermNodeValue.QimeiCount,
    label: i18n.t('影响设备数'),
    disabled: true,
  },
  userUV: {
    value: 1,
    label: i18n.t('影响用户数'),
    disabled: true,
  },
  reportDAU: {
    value: 1,
    label: i18n.t('上报量'),
    disabled: true,
  },
  others: {
    value: 1,
    label: i18n.t('其他数据'),
    disabled: true,
  },
};

// type RolePermissionNodes = Record<Role, PermissionNode[]>;

export const permissionNodeGroup = {
  productInfo: {
    [Role.Admin]: [
      permissionNodes.editProductInfo,
      permissionNodes.deleteProduct,
      permissionNodes.memberManage,
      permissionNodes.permissionManage,
      permissionNodes.dailyReport,
      permissionNodes.tapdConfig,
      permissionNodes.appVersionManage,
      permissionNodes.tagManage,
      permissionNodes.userCustom,
      permissionNodes.issueCluster,
    ],
    [Role.Dev]: [

    ],
    [Role.Op]: [

    ],
  },
  sdkConfig: {
    [Role.Admin]: [
      permissionNodes.addSdkConfig,
      permissionNodes.editSdkConfig,
      permissionNodes.deleteSdkConfig,
      permissionNodes.viewSdkConfig,
      permissionNodes.viewSdkConfigHistory,
    ],
    [Role.Dev]: [
      permissionNodes.viewSdkConfig,
      permissionNodes.viewSdkConfigHistory,
    ],
    [Role.Op]: [
      permissionNodes.viewSdkConfig,
      permissionNodes.viewSdkConfigHistory,
    ],
  },
  alertConfig: {
    [Role.Admin]: [
      permissionNodes.addAlertConfig,
      permissionNodes.editAlertConfig,
      permissionNodes.deleteAlertConfig,
      permissionNodes.viewAlertConfig,
      permissionNodes.toggleAlertConfig,
      permissionNodes.viewAlertHistory,
    ],
    [Role.Dev]: [],
    [Role.Op]: [],
  },
  symbolManage: {
    [Role.Admin]: [
      permissionNodes.uploadSymbol,
      permissionNodes.viewSymbolList,
    ],
    [Role.Dev]: [
      permissionNodes.uploadSymbol,
      permissionNodes.viewSymbolList,
    ],
    [Role.Op]: [
      permissionNodes.uploadSymbol,
      permissionNodes.viewSymbolList,
    ],
  },
  dataView: {
    [Role.Admin]: [
      permissionNodes.deviceDAU,
      permissionNodes.launchDAU,
      permissionNodes.countDAU,
      permissionNodes.deviceUV,
      permissionNodes.userUV,
      permissionNodes.reportDAU,
      permissionNodes.others,
    ],
    [Role.Dev]: [
      {
        ...permissionNodes.deviceDAU,
        disabled: false,
      },
      {
        ...permissionNodes.launchDAU,
        disabled: false,
      },
      permissionNodes.countDAU,
      permissionNodes.deviceUV,
      permissionNodes.userUV,
      permissionNodes.reportDAU,
      permissionNodes.others,
    ],
    [Role.Op]: [
      {
        ...permissionNodes.deviceDAU,
        disabled: false,
      },
      {
        ...permissionNodes.launchDAU,
        disabled: false,
      },
      permissionNodes.countDAU,
      permissionNodes.deviceUV,
      permissionNodes.userUV,
      permissionNodes.reportDAU,
      permissionNodes.others,
    ],
  },
};

export const crashReportPermissionMap = {
  [CrashReportPermission.Alarm]: i18n.t('告警配置'),
  [CrashReportPermission.Symbol]: i18n.t('符号表配置'),
  [CrashReportPermission.Check]: i18n.t('检查管理'),
};

// 内测分发模块
export enum BetaPublishPermission {
  PublishNewVersion = 'publishNewVersion',
  EditVersion = 'editVersion',
  DeleteVersion = 'deleteVersion',
}

export const betaPublishPermissionMap = {
  [BetaPublishPermission.PublishNewVersion]: i18n.t('发布新版本'),
  [BetaPublishPermission.EditVersion]: i18n.t('编辑版本'),
  [BetaPublishPermission.DeleteVersion]: i18n.t('删除版本'),
};

// 内测分发模块
export enum DataPermission {
  ExceptionReport = 'exceptionReport',
  OperateStatistics = 'operateStatistics',
}

export const dataPermissionMap = {
  [DataPermission.ExceptionReport]: i18n.t('异常上报数据'),
  [DataPermission.OperateStatistics]: i18n.t('运营统计数据'),
};

export const developerDataPermissionMap = {
  [DataPermission.ExceptionReport]: i18n.t('异常上报数据'),
};

export const operatorDataPermissionMap = {
  [DataPermission.ExceptionReport]: i18n.t('异常上报数据'),
  [DataPermission.OperateStatistics]: i18n.t('运营统计数据'),
};

export interface PermissionConfig {
  role: string;
  roleTitle: ReactNode;
  productInfo: PermissionNode[],
  sdkConfig: PermissionNode[],
  alertConfig: PermissionNode[],
  symbolManage: PermissionNode[],
  dataView: PermissionNode[],
}

export const PERMISSION_CONFIG: PermissionConfig[] = [
  {
    role: '管理员',
    roleTitle: (
      <Space>
        {/* @ts-ignore */}
        <Icon component={AdminIcon}></Icon>
        <span>{i18n.t('管理员')}</span>
      </Space>
    ),
    productInfo: permissionNodeGroup.productInfo[Role.Admin],
    sdkConfig: permissionNodeGroup.sdkConfig[Role.Admin],
    alertConfig: permissionNodeGroup.alertConfig[Role.Admin],
    symbolManage: permissionNodeGroup.symbolManage[Role.Admin],
    dataView: permissionNodeGroup.dataView[Role.Admin],
  },
  {
    role: '开发人员',
    roleTitle: (
      <Space>
        {/* @ts-ignore */}
        <Icon component={DeveloperIcon}></Icon>
        <span>{i18n.t('开发人员')}</span>
      </Space>
    ),
    productInfo: permissionNodeGroup.productInfo[Role.Dev],
    sdkConfig: permissionNodeGroup.sdkConfig[Role.Dev],
    alertConfig: permissionNodeGroup.alertConfig[Role.Dev],
    symbolManage: permissionNodeGroup.symbolManage[Role.Dev],
    dataView: permissionNodeGroup.dataView[Role.Dev],
  },
  {
    role: '运营人员',
    roleTitle: (
      <Space>
        {/* @ts-ignore */}
        <Icon component={OperatorIcon}></Icon>
        <span>{i18n.t('运营人员')}</span>
      </Space>
    ),
    productInfo: permissionNodeGroup.productInfo[Role.Op],
    sdkConfig: permissionNodeGroup.sdkConfig[Role.Op],
    alertConfig: permissionNodeGroup.alertConfig[Role.Op],
    symbolManage: permissionNodeGroup.symbolManage[Role.Op],
    dataView: permissionNodeGroup.dataView[Role.Op],
  },
];
